import React from 'react';

const Agreement = () => (
  <div>
    <strong>・施設使用にあたっての留意事項</strong><br/>
    施設の使用の権利は、他人に譲渡し、または転貸することはできません。事前準備、原状回復（清掃を含む）は許可された時間内に使用者側で行ってください。施設及び備品の使用に当たっては、係員の指示に従ってください。<br/>
    <br/>
    <strong>・利用料金の還付</strong><br/>
    お支払いただいた利用料金は、利用者の都合により取り止めされた場合、お返しできませんのでご注意ください。ただし、下記に掲げる期間内に「使用取りやめ届」及び「利用料金還付申請書」を提出していただいた場合には、利用料金の全部または一定金額をお返しします。<br/>
    ・使用日の90日前...利用料金の全額<br/>
    ・使用日の60日前...利用料金の範囲内で市長が別に定める還付基準額（以下「還付基準額」という。）の7割に相当する額及び利用料金から還付基準額を差し引いた額<br/>
    ・使用日の30日前...還付基準額の5割に相当する額及び利用料金から還付基準額を差し引いた額<br/>
    ・使用日の7日前...利用料金から還付基準額を差し引いた額<br/>
    ・使用日の6日前...還付なし<br/>

  </div>
);

export default Agreement;
